<template>
    <div>
        <div class="page-group-title"><span>{{params.rangeStart}} 至 {{params.rangeEnd}}</span></div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="targetId" label="直播事件ID"></el-table-column>
                <el-table-column prop="targetName" label="直播事件名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="totalNum" label="预约人数"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
const defaultParams = {
    pageNo:1,
    rangeStart:'',
    rangeEnd:'',
    // timeStart: "00:00:00",
    // timeEnd: "23:59:59"
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
                rangeStart: this.$route.query.rangeStart || null,
                rangeEnd: this.$route.query.rangeEnd || null,
            },
            listLoading: false,    
        }
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/hot/live/subscribe/list",
                method: "POST",
                data: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
    }
}
</script>